#import "../fragments/competitors-lead-fragment.graphql"

mutation LeadUpdateCompetitor($input: LeadCompetitorUpdateInput!) {
    leadCompetitorUpdate(input: $input) {
        lead {
            ...CompetitorsLeadFragment
        }
    }
}
